// removed by extract-text-webpack-plugin
module.exports = {"popover":"antd-pro-notice-icon-popover","noticeButton":"antd-pro-notice-icon-noticeButton","icon":"antd-pro-notice-icon-icon","tabs":"antd-pro-notice-icon-tabs"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/NoticeIcon/index.less
// module id = 628
// module chunks = 0